<template>
  <absolutely-layout :enable-scroll-event="true" :show-footer="true">
    <div class="flex flex-col w-screen min-h-screen bg-[#F6F5F1] font-[Inter]">
      <div class="px-5 py-8">
        <h1 class="text-h2 text-[#3D3A35] mb-6">Episodes</h1>
        <div class="flex flex-col gap-4">
          <div
            v-for="chapter in chapters"
            :key="chapter.id"
            class="bg-white rounded-lg p-5 shadow-sm cursor-pointer"
            @click="navigateToChapter(chapter.id)"
          >
            <h2 class="text-[1.125rem] font-semibold text-[#3D3A35] mb-2">
              {{ chapter.chapterName }}
            </h2>
            <p class="text-body-1 text-[#2B2926]">{{ chapter.description }}</p>
          </div>
          <div v-if="chapters.length === 0" class="text-center py-8">
            <p class="text-body-1 text-[#2B2926]">No episodes available yet.</p>
          </div>
        </div>
      </div>
    </div>
  </absolutely-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import AbsolutelyAccessMixin from '@/mixins/AbsolutelyAccess';

export default {
  name: 'ChapterIndex',
  mixins: [AbsolutelyAccessMixin],
  data() {
    return {
      chapters: [],
    };
  },
  computed: {
    ...mapGetters('absolutely', ['getChapters']),
  },
  methods: {
    ...mapActions('absolutely', ['fetchContent']),
    navigateToChapter(chapterId) {
      this.$router.push(`/absolutely/chapter/${chapterId}`);
    },
    loadChapters() {
      this.chapters = this.getChapters;
    },
  },
  async ionViewWillEnter() {
    // Check access
    if (!this.checkAbsolutelyAccess()) return;

    // Ensure content is loaded (handles initial load and refresh scenarios)
    await this.fetchContent({ refresh: false });
    this.loadChapters();
  },
};
</script>

<style scoped></style>
